import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g fill="#0DD3C5" fillRule="evenodd">
      <path d="M9.172 2.71L3 6l9 5.005 9-4.986-6.174-3.305a6 6 0 00-5.654-.004z" />
      <path
        d="M5.946 18.393L12 22V11L3 6l.017 7.252a6 6 0 002.929 5.14z"
        opacity={0.8}
      />
      <path
        d="M12 11v11l6.054-3.607a6 6 0 002.93-5.141L21 6l-9 5z"
        opacity={0.5}
      />
    </g>
  </svg>
);
